import { createContext } from 'react';
const initialState = {
    publisherID: null
}

const UserContext = createContext(initialState);


export default UserContext;